import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import Feature from 'ol/Feature'
import { Stroke, Style } from 'ol/style'
import useMap from 'hooks/use-map'
import { get } from 'es-toolkit/compat'

export default function ElevationLineLayer() {
  const map = useMap()
  const geometry = useSelector((state) => get(state, 'map.elevationProfileReq'))
  const [layer, setLayer] = useState(null)

  useEffect(() => {
    if (!map) return
    const source = new VectorSource()
    const vectorLayer = new VectorLayer({
      source,
      style: new Style({
        stroke: new Stroke({
          color: '#3475E0',
          width: 3,
        }),
      }),
      zIndex: 100, // Make sure it sits on top
    })

    map.addLayer(vectorLayer)
    setLayer(vectorLayer)

    return () => {
      map.removeLayer(vectorLayer)
    }
  }, [map])

  useEffect(() => {
    if (!layer) return
    const source = layer.getSource()
    source.clear()

    if (geometry) {
      const feature = new Feature({ geometry })
      source.addFeature(feature)
    }
  }, [layer, geometry])

  return null
}
